import React, {useEffect, useState, useContext} from "react";
import appContext from "../../../context/appContext";
import Styles from "./conformanceChecking/CardContent/CardContent.module.scss";
import {Scrollbars} from "react-custom-scrollbars";
import UnwantedActivity from "./conformanceChecking/CardContent/UnwantedActivity";
import UnwantedSequence from "./conformanceChecking/CardContent/UnwantedSequence";
import Loading from "../../Componnets/Loading";
import {createDataPost} from "../../../util/util";
import http from "../../../services/api/utilities/http";

const ConformanceChecking = (props) => {
    const context = useContext(appContext);
    const [data, setData] = useState(null)
    const [callSave, setCallSave] = useState(false)
    const handleToggleFullScreen = () => {
        // setExpanded(!expanded);
        const el = document.querySelectorAll('.indexContents');
        el[0].classList.toggle('fullScreen');
    }
    // const {conformanceCheckingSaveObj,bpmnId} = context.state
    let {
        bpmnId,
        conformanceCheckingVariants,
        conformanceCheckingActiveVariants,
        conformanceCheckingFilters,
        conformanceCheckingFlow,
        conformanceCheckingMetrics,
        conformanceCheckingAdvancedActivityFilters
    } = context.state
    useEffect(() => {
        if (callSave) fetchConformanceChecking()
    }, [conformanceCheckingVariants, conformanceCheckingActiveVariants, conformanceCheckingFilters, conformanceCheckingFlow, conformanceCheckingMetrics,conformanceCheckingAdvancedActivityFilters, callSave])
    useEffect(() => {
        return () => {
            if (data) setSave()
        }
    }, [data])
    useEffect(() => {
        getSave()
    }, [])

    const getSave = () => {
        setData(false)
        http.get(
            `/process_mining/save_conformance_state/${context.handleUid().id}`
        ).then(res => {
                let {variants, activeVariants, filters, flow, metrics, bpmn_id , conformanceCheckingAdvancedActivityFilters} = res.data.data.conformance_state
                if (bpmn_id) context.dispatch({type: 'set_bpmn_id', value: bpmn_id})
                if (variants) context.dispatch({type: 'set_conformance_checking_filters', value: filters})
                if (activeVariants) context.dispatch({type: 'set_conformance_checking_flow', value: flow})
                if (filters) context.dispatch({type: 'set_conformance_checking_variants', value: variants})
                if (flow) context.dispatch({type: 'set_conformance_checking_active_variants', value: activeVariants})
                if (metrics) context.dispatch({type: 'set_conformance_checking_metrics', value: metrics})
                if (conformanceCheckingAdvancedActivityFilters) context.dispatch({type: 'set_conformance_checking_advanced_activity_filters', value: conformanceCheckingAdvancedActivityFilters})
                setCallSave(true)
            }).catch(er => {
            setCallSave(true)
        })
    }
    const setSave = () => {
        http.post('process_mining/save_conformance_state/' + context.handleUid().id,
            {
                'conformance_state': {
                    bpmn_id: bpmnId,
                    variants: conformanceCheckingVariants,
                    activeVariants: conformanceCheckingActiveVariants,
                    filters: conformanceCheckingFilters,
                    flow: conformanceCheckingFlow,
                    metrics: conformanceCheckingMetrics,
                    conformanceCheckingAdvancedActivityFilters
                }
            })
            .then(res => {
            })
            .catch(er => console.log(er))
    }
    const fetchConformanceChecking = () => {
        context.actionFilter('fetching')
        let token = localStorage.getItem('token')
        let id = context.handleUid().id
        if(id){
            localStorage.setItem('bpmn_pk',bpmnId)
            localStorage.setItem('id',id)
        }else{
           bpmnId = localStorage.getItem('bpmn_pk')
           id = localStorage.getItem('id')
        }
        let data = createDataPost({
            bpmn_pk: bpmnId,
            variants: conformanceCheckingVariants,
            active_variants: conformanceCheckingActiveVariants,
            filters: conformanceCheckingFilters,
            flow: conformanceCheckingFlow,
            metrics: conformanceCheckingMetrics,
            advanced_activity_filters: conformanceCheckingAdvancedActivityFilters
        })
        http.post('process_mining/conformance_checking/' + id , data )
            .then(res => {
                if (res.data.data.error) {
                    context.actionFilter('error')
                } else {
                    context.actionFilter('success')
                    setData(res.data.data)
                    console.log(res.data.data, data)
                }
            })
            .catch(er => {
                context.actionFilter('error')
                console.log(er)
            })
    }
    return (
        data ?
            <>
                <div className="d-flex justify-content-end">
                    <div className="d-flex">
                        <div className={Styles.search}>
                            <input placeholder="Search"/>
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.8055" cy="8.80547" r="7.49047" stroke="#0A195C" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14.0153 14.4042L16.9519 17.3333" stroke="#0A195C" stroke-width="1.5"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div className={`${Styles.casesBox} d-flex justify-content-between align-items-center`}>
                            <div onClick={() => console.log(context.state.conformanceCheckingVariants)}>
                                <p>Conformance Rate</p>
                            </div>
                            <svg className={Styles.border} width="1" height="39" viewBox="0 0 1 39" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="39" stroke="#C2C7ED"
                                      stroke-dasharray="5 5"/>
                            </svg>
                            <div className="d-flex align-items-center">
                                <svg className={Styles.icon} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.14286 8.50146V14.2182" stroke="#8A0FFF" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.0318 5.76593V14.2182" stroke="#8A0FFF" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.8572 11.5224V14.2182" stroke="#8A0FFF" stroke-width="1.5"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M13.9048 1.66669H6.09526C3.37304 1.66669 1.66669 3.59342 1.66669 6.32098V13.6791C1.66669 16.4066 3.3651 18.3334 6.09526 18.3334H13.9048C16.6349 18.3334 18.3334 16.4066 18.3334 13.6791V6.32098C18.3334 3.59342 16.6349 1.66669 13.9048 1.66669Z"
                                          stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                </svg>
                                <p>{((data?.log_fitness?.total_number_of_cases * data?.log_fitness?.percent_of_fitting_traces) / 100).toFixed(0)} of {data?.log_fitness?.total_number_of_cases}</p>
                                <span>Cases</span>
                            </div>
                            <svg className={Styles.border} width="1" height="39" viewBox="0 0 1 39" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="39" stroke="#C2C7ED"
                                      stroke-dasharray="5 5"/>
                            </svg>
                            <div className="d-flex align-items-center">
                                <svg className={Styles.icon} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M14.3983 11.5743C14.9605 11.5743 15.4325 12.0383 15.3465 12.5936C14.8421 15.8603 12.0456 18.2857 8.67283 18.2857C4.94125 18.2857 1.91669 15.2611 1.91669 11.5304C1.91669 8.45674 4.25177 5.59359 6.88072 4.94622C7.44563 4.80674 8.02458 5.20411 8.02458 5.78569C8.02458 9.72604 8.15704 10.7453 8.90528 11.2997C9.65353 11.8541 10.5334 11.5743 14.3983 11.5743Z"
                                          stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M18.0772 8.293C18.1219 5.76142 15.0122 1.68072 11.2228 1.75089C10.928 1.75616 10.6921 2.00177 10.6789 2.29563C10.5833 4.37721 10.7122 7.07458 10.7842 8.29738C10.8061 8.67809 11.1052 8.97721 11.485 8.99914C12.7421 9.07107 15.5377 9.16931 17.5894 8.85879C17.8684 8.81668 18.0728 8.57458 18.0772 8.293Z"
                                          stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                </svg>
                                <p>{(data.log_fitness.percent_of_fitting_traces).toFixed(0)} %</p>
                                <span>of Cases</span>
                            </div>
                        </div>
                        <div className={`${Styles.checkBox} d-flex justify-content-around align-items-center`}>
                            <p>BPMN Model</p>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M5.39175 0.666565H12.6167C15.4417 0.666565 17.3334 2.6499 17.3334 5.5999V12.4091C17.3334 15.3499 15.4417 17.3332 12.6167 17.3332H5.39175C2.56675 17.3332 0.666748 15.3499 0.666748 12.4091V5.5999C0.666748 2.6499 2.56675 0.666565 5.39175 0.666565ZM8.52508 11.4916L12.4834 7.53323C12.7667 7.2499 12.7667 6.79156 12.4834 6.4999C12.2001 6.21656 11.7334 6.21656 11.4501 6.4999L8.00841 9.94157L6.55008 8.48323C6.26675 8.1999 5.80008 8.1999 5.51675 8.48323C5.23341 8.76656 5.23341 9.2249 5.51675 9.51657L7.50008 11.4916C7.64175 11.6332 7.82508 11.6999 8.00841 11.6999C8.20008 11.6999 8.38341 11.6332 8.52508 11.4916Z"
                                      fill="#02DEAB"/>
                            </svg>
                        </div>

                        <svg className="pointer" onClick={handleToggleFullScreen} width="39" height="39"
                             viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="39" height="39" rx="10" fill="#8A0FFF"/>
                            <path
                                d="M11.8932 21.2954L12.6136 21.0869L11.8932 21.2954ZM11.8932 15.7554L11.1727 15.547H11.1727L11.8932 15.7554ZM26.1069 15.7555L26.8273 15.547L26.8273 15.547L26.1069 15.7555ZM26.1069 21.2954L25.3864 21.0869L25.3864 21.0869L26.1069 21.2954ZM23.0123 24.1729L22.8722 23.4361L23.0123 24.1729ZM14.9877 24.1729L15.1278 23.4361L14.9877 24.1729ZM14.9877 12.8779L14.8476 12.1411L14.9877 12.8779ZM23.0123 12.8779L23.1524 12.1411L23.0123 12.8779ZM11.9334 21.4344L11.2129 21.6429L11.9334 21.4344ZM26.0666 21.4344L26.7871 21.6428L26.7871 21.6428L26.0666 21.4344ZM26.0666 15.6164L25.3462 15.8249V15.8249L26.0666 15.6164ZM11.9334 15.6164L12.6538 15.8249L11.9334 15.6164ZM19.75 24.9358C19.75 24.5216 19.4142 24.1858 19 24.1858C18.5858 24.1858 18.25 24.5216 18.25 24.9358H19.75ZM18.25 27.5C18.25 27.9142 18.5858 28.25 19 28.25C19.4142 28.25 19.75 27.9142 19.75 27.5H18.25ZM16.8032 26.75C16.389 26.75 16.0532 27.0858 16.0532 27.5C16.0532 27.9142 16.389 28.25 16.8032 28.25V26.75ZM21.1968 28.25C21.611 28.25 21.9468 27.9142 21.9468 27.5C21.9468 27.0858 21.611 26.75 21.1968 26.75V28.25ZM25.3462 15.8249L25.3864 15.9639L26.8273 15.547L26.7871 15.408L25.3462 15.8249ZM25.3864 21.0869L25.3462 21.2259L26.7871 21.6428L26.8273 21.5038L25.3864 21.0869ZM12.6538 21.2259L12.6136 21.0869L11.1727 21.5039L11.2129 21.6429L12.6538 21.2259ZM12.6136 15.9639L12.6538 15.8249L11.2129 15.408L11.1727 15.547L12.6136 15.9639ZM12.6136 21.0869C12.1288 19.4116 12.1288 17.6392 12.6136 15.9639L11.1727 15.547C10.6091 17.4946 10.6091 19.5562 11.1727 21.5039L12.6136 21.0869ZM25.3864 15.9639C25.8712 17.6392 25.8712 19.4116 25.3864 21.0869L26.8273 21.5038C27.3909 19.5562 27.3909 17.4946 26.8273 15.547L25.3864 15.9639ZM22.8722 23.4361C20.315 23.9224 17.685 23.9224 15.1278 23.4361L14.8476 24.9097C17.59 25.4312 20.41 25.4312 23.1524 24.9097L22.8722 23.4361ZM15.1278 13.6147C17.685 13.1284 20.315 13.1284 22.8722 13.6147L23.1524 12.1411C20.41 11.6196 17.59 11.6196 14.8476 12.1411L15.1278 13.6147ZM15.1278 23.4361C13.9287 23.2082 12.9781 22.3464 12.6538 21.2259L11.2129 21.6429C11.6991 23.323 13.111 24.5796 14.8476 24.9097L15.1278 23.4361ZM23.1524 24.9097C24.889 24.5796 26.3009 23.323 26.7871 21.6428L25.3462 21.2259C25.0219 22.3464 24.0713 23.2082 22.8722 23.4361L23.1524 24.9097ZM22.8722 13.6147C24.0713 13.8427 25.0219 14.7044 25.3462 15.8249L26.7871 15.408C26.3009 13.7278 24.889 12.4713 23.1524 12.1411L22.8722 13.6147ZM14.8476 12.1411C13.111 12.4713 11.6991 13.7278 11.2129 15.408L12.6538 15.8249C12.9781 14.7044 13.9287 13.8427 15.1278 13.6147L14.8476 12.1411ZM18.25 24.9358V27.5H19.75V24.9358H18.25ZM16.8032 28.25H21.1968V26.75H16.8032V28.25Z"
                                fill="white"/>
                        </svg>

                    </div>
                </div>
                <Scrollbars className={`scroll ${Styles.scroll}`}
                            style={{marginTop: 20, width: '100%', height: 'calc(100vh - 247px)'}}>
                    {data && data.undesired_activities.length > 0
                    &&
                    <div className="d-flex">
                        <div className={`d-flex align-items-center justify-content-center ${Styles.label}`}>
                            {/*<div>Unwanted Activities</div>*/}
                        </div>
                        <div style={{width: 'calc(100% - 0px)'}} className="row">
                            {data && data.undesired_activities.map((card, key) => (
                                <UnwantedActivity key={key} card={card}/>
                            ))}
                        </div>
                    </div>
                    }
                    <div className="d-flex">
                        <div className={`d-flex align-items-center justify-content-center ${Styles.sequenceLabel}`}>
                            {/*<div>Unwanted Activities</div>*/}
                        </div>
                        <div style={{width: 'calc(100% - 0px)'}} className="row">
                            {data && data.undesired_sequences.map((card, key) => (
                                <UnwantedSequence card={card} key={key}/>
                            ))}
                        </div>
                    </div>
                </Scrollbars>
            </>
            :
            <Loading/>
    )
};

export default ConformanceChecking;
